import React, { createContext } from 'react';

export const defaultSettings = {
  locale: 'en-US',
  theme: 'light',
  overlay: 'dialog',
};

export const SettingsContext = createContext({
  ...defaultSettings,
  handleUpdate: () => {},
}); 